import Axios from 'axios'
import store from '@/store'

const axios = Axios.create({
  baseURL: '/arrecadacao/api',
  maxRedirects: 0
})

axios.interceptors.request.use(function (request) {
  if(window.location.pathname != '/arrecadacao/arearestrita/emitir/guiatela') {
    request.headers['origem'] = 'PUBLICO'
  }
  else {    
    request.headers['origem'] = 'RECEITA'
  }

  return request
},
function (error) {  
    return Promise.reject({ response: { data: { message: 'Algum recurso desta funcionalidade encontra-se indisponível. Por favor, tente mais tarde ou entre em contato com o analista responsável.' } } })
}
),

axios.interceptors.response.use(function (response) {
  return response
},

function (error) {
  if (error === 'Error: Network Error') {
    if (error.response === undefined) {
      var networkError = { response: { data: { message: 'Algum recurso desta funcionalidade encontra-se indisponível. Por favor, tente mais tarde ou entre em contato com o analista responsável.' } } }
      error = networkError
      store.dispatch('message/setMessages', {
        message: networkError.response.data.message,
        variant: 'danger'
      })
    }
  }

  if (error.response !== undefined && error.response.status === 403) {
    var permissionError = { response: { data: { message: 'Sem permissão de acesso para alguns recursos desta funcionalidade (403).' } } }
    error = permissionError
    store.dispatch('message/setMessages', {
      message: permissionError.response.data.message,
      variant: 'danger'
    })
  }

  if (error.response !== undefined && error.response.status === 500) {
    var genericError = { response: { data: { message: 'Ocorreu um erro. Por favor, entre em contato com o administrador (500).' } } }
    error = genericError
    store.dispatch('message/setMessages', {
      message: genericError.response.data.message,
      variant: 'danger'
    })
  }

  return Promise.reject(error)
})

export default axios
